export default __webpack_public_path__ + "5927dd784f8a2dc3ffcc2118e850eaab.png";